import React from 'react';
import { Edit } from 'react-admin';
import { withStyles } from '@material-ui/core/styles';
import FormTitleBar from '../../core/components/FormTitleBar';
import { getInitials } from '../../core/utils';
import ReportSummary from './ReportSummary';
import CustomSimpleForm from '../../core/components/form/CustomSimpleForm';

const styles = () => ({
  gridTab: {
    marginTop: '-17px !important'
  },
  noActions: {
    marginTop: '0px',
    height: '100%'
  },
  edit: {
    height: '100%'
  },
  form: {
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    '& .MuiCardContent-root': {
      height: '100%',
      overflow: 'hidden',
      '& .ra-input': {
        height: '100%'
      }
    }
  }
});

const ReportTitle = ({ record }) => {
  return (
    <FormTitleBar
      name={record.name}
      showAvatar={true}
      avatarContent={getInitials(record.name)}
    />
  );
};

class ReportEdit extends React.Component {
  render() {
    const {
      classes,
      hasCreatePermission,
      hasEditPermission,
      hasDeletePermission,
      userProfile,
      ...rest
    } = this.props;

    return (
      <Edit
        {...rest}
        undoable={false}
        title={<ReportTitle />}
        classes={{ noActions: classes.noActions, root: classes.edit }}
      >
        <CustomSimpleForm
          toolbar={null}
          variant="standard"
          margin="normal"
          className={classes.form}
        >
          <ReportSummary variant="standard" />
        </CustomSimpleForm>
      </Edit>
    );
  }
}

export default withStyles(styles)(ReportEdit);
